import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'toLightTagTypeBadge' })
export class LightTagTypePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value?: boolean | null): string {
    const type = value === true ? 'listening' : 'legacy';
    const icon = value === true ? 'hearing' : 'lightbulb';
    const text = this.translate.instant(`lighttag.typeValues.${type}`);

    return (
      `<div class="badge rounded-pill text-bg-light d-inline-flex align-items-center gap-1">` +
      `<span class="material-symbols-outlined fs-6 lh-1">${icon}</span>` +
      `<span>${text}</span>` +
      '</div>'
    );
  }
}
